import React, {useContext} from 'react';
import {useMutation} from '@tanstack/react-query';
import {css} from '@emotion/css';
import {ToastType} from 'patient-ping-remedy/packages/toast';
import {SmallTypography} from 'patient-ping-remedy/packages/typography';
import Button from 'patient-ping-remedy/packages/button';
import InfoIconTooltip from '@common/InfoIconTooltip';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {useAlertStore} from '@/store/alert_store';
import Helpers from "@/helpers/helpers";
import {AxiosError} from "axios";

export default function DiagnosisCodesUpdate() {
  const { carecoApi } = useContext(CarecoApiContext);
  const { addAlert } = useAlertStore();

  const { mutate, isPending } = useMutation({
    mutationFn: async () =>
      carecoApi?.postDiagnosisCodesUpdateTool(),
    onSuccess() {
      addAlert({
        content: 'Diagnosis codes update has been started in the background.',
        type: ToastType.SUCCESS,
      });
    },
    onError(error: AxiosError) {
      Helpers.alertOnError( 'Failed to start diagnosis codes update', error);
    },
  });

  return (
    <>
      <div>
        <SmallTypography>To update <code>diagnosis_codes</code> table, click button below </SmallTypography>
        <InfoIconTooltip
          text={'This will read "resources/data/diagnosis-codes.csv" file and ' +
            'synchronize all entries with database records.'}
        />
      </div>
      <Button
        className={css({ marginTop: '30px' })}
        disabled={isPending}
        onClick={() => mutate()}
      >
        Update
      </Button>
    </>
  );
}
